const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

if (!customElements.get('product-sticky-atc')) {
  customElements.define('product-sticky-atc', class ProductStickyAtc extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      this.form = this.closest('form');
      this.root = this.closest('.product');
      this.originalSubmit = [...(this.form?.querySelectorAll('.product-selector__submit') || [])].find(button => !this.contains(button));
      this.quantity = this.form?.querySelector('.product-selector__quantity input[name="quantity"]');
      this.input = this.querySelector('[data-sticky-quantity]');
      this.submit = this.querySelector('[data-sticky-submit]');
      if (!this.root || !this.originalSubmit || !this.quantity || !this.input || !this.submit) return;
      try { this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent); } catch { this.variants = []; }
      this.priceSource = this.root.querySelector(`#Product-Price-${CSS.escape(this.dataset.sectionId)}`);
      this.onClick = event => {
        const step = event.target.closest('[data-sticky-step]');
        if (step && !step.disabled) {
          this.normalizeQuantity();
          Number(step.dataset.stickyStep) > 0 ? this.input.stepUp() : this.input.stepDown();
          this.normalizeQuantity();
          this.writeQuantity();
        }
        if (event.target.closest('[data-sticky-submit]') && !this.submit.disabled && !this.originalSubmit.disabled && !this.originalSubmit.classList.contains('disabled')) {
          this.normalizeQuantity();
          this.writeQuantity();
          // Use the existing form, subscription validation, cart drawer and Panettone guard.
          this.originalSubmit.click();
        }
      };
      this.onInput = event => {
        if (event.target === this.input) {
          // Let users finish typing; validate on blur/change or before submission.
          if (this.input.value !== '') this.quantity.value = this.input.value;
        } else if (event.target === this.quantity) {
          this.syncQuantity();
        }
      };
      this.onChange = event => {
        if (event.target === this.input) { this.normalizeQuantity(); this.writeQuantity(); }
        else if (event.target.name === 'id') this.syncVariant();
        else if (event.target === this.quantity) this.syncQuantity();
      };
      this.onBlur = () => { this.normalizeQuantity(); this.writeQuantity(); };
      this.addEventListener('click', this.onClick);
      this.form.addEventListener('input', this.onInput);
      this.root.addEventListener('change', this.onChange);
      this.input.addEventListener('blur', this.onBlur);
      this.buttonObserver = new MutationObserver(() => this.syncButton());
      this.buttonObserver.observe(this.originalSubmit, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true, characterData: true });
      this.quantityObserver = new MutationObserver(() => this.syncQuantity());
      this.quantityObserver.observe(this.quantity, { attributes: true, attributeFilter: ['min', 'max', 'step', 'value'] });
      if (this.priceSource) {
        this.priceObserver = new MutationObserver(() => this.syncPrice());
        this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
      }
      const gallery = this.root.querySelector('.product__media');
      const visible = new Map([[this.originalSubmit, false]]);
      if (gallery) visible.set(gallery, false);
      this.visibilityObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
        const show = ![...visible.values()].some(Boolean);
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0.01 });
      visible.forEach((_, element) => this.visibilityObserver.observe(element));
      this.syncVariant();
      this.syncPrice();
      this.syncButton();
    }

    syncVariant() {
      const id = String(this.form.elements.namedItem('id')?.value || '');
      const variant = this.variants.find(item => String(item.id) === id);
      if (!variant || this.variantId === id) return;
      this.variantId = id;
      this.variant = variant;
      this.quantity.min = variant.min || 1;
      this.quantity.step = variant.step || 1;
      this.quantity.max = variant.max == null ? '' : variant.max;
      this.syncQuantity();
      const holder = this.querySelector('[data-sticky-image]');
      if (variant.image) {
        let image = holder.querySelector('img');
        if (!image) { image = document.createElement('img'); holder.replaceChildren(image); }
        image.removeAttribute('srcset');
        image.src = variant.image.src;
        image.alt = variant.image.alt;
        image.width = variant.image.width;
        image.height = variant.image.height;
      } else { holder.replaceChildren(); }
      const price = document.createElement('div');
      price.className = variant.comparePrice ? 'price__sale-inner' : 'price__regular';
      if (variant.comparePrice) { const compare = document.createElement('del'); compare.textContent = variant.comparePrice; price.append(compare); }
      const amount = document.createElement(variant.comparePrice ? 'ins' : 'span'); amount.textContent = variant.price; price.append(amount);
      this.querySelector('[data-sticky-price]').replaceChildren(price);
      this.syncButton();
    }

    syncPrice() {
      const source = this.priceSource?.querySelector('.price__sale, .price__regular');
      if (source) this.querySelector('[data-sticky-price]').replaceChildren(source.cloneNode(true));
    }

    syncQuantity() {
      for (const name of ['min', 'max', 'step']) this.input.setAttribute(name, this.quantity.getAttribute(name) || (name === 'max' ? '' : '1'));
      this.input.value = this.quantity.value;
      this.normalizeQuantity();
      this.quantity.value = this.input.value;
      this.quantity.closest('quantity-input')?.updateButtonColors?.();
    }

    normalizeQuantity() {
      const min = Number(this.input.min) || 1, step = Number(this.input.step) || 1;
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      let value = Number(this.input.value);
      if (!Number.isFinite(value) || value < min) value = min;
      value = min + Math.floor((value - min) / step) * step;
      if (Number.isFinite(max)) value = max < min ? min : Math.min(value, min + Math.floor((max - min) / step) * step);
      this.input.value = value;
      this.querySelector('[data-sticky-step="-1"]').disabled = value <= min;
      this.querySelector('[data-sticky-step="1"]').disabled = value + step > max;
    }

    writeQuantity() {
      this.quantity.value = this.input.value;
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      this.quantity.closest('quantity-input')?.updateButtonColors?.();
    }

    syncButton() {
      const busy = this.originalSubmit.classList.contains('disabled');
      this.submit.disabled = this.originalSubmit.disabled || busy || this.variant?.available === false;
      this.submit.textContent = this.originalSubmit.textContent.trim();
      this.submit.setAttribute('aria-busy', String(busy));
      this.input.disabled = this.variant?.available === false;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      [this.buttonObserver, this.quantityObserver, this.priceObserver, this.visibilityObserver].forEach(observer => observer?.disconnect());
      this.removeEventListener('click', this.onClick);
      this.form?.removeEventListener('input', this.onInput);
      this.root?.removeEventListener('change', this.onChange);
      this.input?.removeEventListener('blur', this.onBlur);
    }
  });
}
